import { render, staticRenderFns } from "./TextViewer.vue?vue&type=template&id=b721e29a&"
import script from "./TextViewer.vue?vue&type=script&lang=js&"
export * from "./TextViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports